import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api, { tokenStorage } from '../lib/api';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch (err) {
      // 401 expected when no valid token/cookie — silent fail
      if (err?.response?.status && err.response.status !== 401) {
        // Non-401 errors logged only in dev
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error('Auth check failed:', err);
        }
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = tokenStorage.get();
    if (token) {
      fetchMe();
    } else {
      setLoading(false);
    }
  }, [fetchMe]);

  const login = async (username, password) => {
    const { data } = await api.post('/auth/login', { username, password });
    tokenStorage.set(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (_err) {
      // Logout errors are non-critical — cookie/storage cleared regardless
    }
    tokenStorage.clear();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh: fetchMe }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
